import { navLinks } from "@/mocks/comicGuide";

export default function Footer() {
  return (
    <footer className="w-full bg-background-100 pt-12 pb-6 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-mental-health-line text-xl"></i>
              </span>
              <span className="font-heading text-xl text-foreground-900">66漫画网</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              让下拉、翻页、目录、全屏四种阅读方式随心切换，阅读设置清晰易懂，
              第一次来也能顺畅看完全篇。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">站内导航</h4>
            <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-foreground-600 hover:text-primary-600"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">意见反馈</h4>
            <p className="mt-4 text-sm text-foreground-600">
              如果在阅读时遇到任何问题，欢迎告诉我们，我们会持续优化阅读体验。
            </p>
            <a
              href="mailto:contact@66comic-guide.com"
              className="mt-3 inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700"
            >
              <i className="ri-mail-line"></i>
              contact@66comic-guide.com
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 66漫画网 · 阅读方式操作指南
          </p>
          <p className="text-xs text-foreground-500">
            下拉 · 翻页 · 目录 · 全屏
          </p>
        </div>
      </div>
    </footer>
  );
}